import alpha from "color-alpha";
const filledStyles = ({
  theme,
  ownerState
}) => {
  if (ownerState.variant !== "filled")
    return;
  const white = theme.palette.common.white ?? "#fff";
  return {
    ...ownerState.color === "aqua" && {
      backgroundColor: theme.palette.primary[800],
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: "#1f7564",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: "#267A69",
        boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.primary[800]}, 0px 1px 2px 3px rgba(0, 0, 0, 0.3), 0px 1px 3px 4px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey[900], 0.12),
        color: alpha(theme.palette.grey[900], 0.38)
      }
    },
    ...ownerState.color === "purple" && {
      backgroundColor: theme.palette.highlight3[700],
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.highlight3[600],
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: theme.palette.highlight3[500],
        boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.primary[800]}, 0px 1px 2px 3px rgba(0, 0, 0, 0.3), 0px 1px 3px 4px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey[900], 0.12),
        color: alpha(theme.palette.grey[900], 0.38)
      }
    },
    ...ownerState.color === "blue" && {
      backgroundColor: theme.palette.highlight2[700],
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: theme.palette.highlight2[600],
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: theme.palette.highlight2[500],
        boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.primary[800]}, 0px 1px 2px 3px rgba(0, 0, 0, 0.3), 0px 1px 3px 4px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey[900], 0.12),
        color: alpha(theme.palette.grey[900], 0.38)
      }
    },
    ...ownerState.color === "orange" && {
      backgroundColor: theme.palette.secondary[200],
      color: theme.palette.grey[900],
      "&:hover": {
        backgroundColor: "#F4B395",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.15), 0px 0px 2px rgba(0, 0, 0, 0.05);"
      },
      "&:focus-visible": {
        backgroundColor: "#F5B699",
        boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.secondary[200]}, 0px 1px 2px 3px rgba(0, 0, 0, 0.3), 0px 1px 3px 4px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey[900], 0.12),
        color: alpha(theme.palette.grey[900], 0.38)
      }
    },
    ...ownerState.color === "grey" && {
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: "#595959",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: "#5E5E5E",
        boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.grey[800]}, 0px 1px 2px 3px rgba(0, 0, 0, 0.3), 0px 1px 3px 4px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey[800], 0.12),
        color: alpha(white, 0.38)
      }
    },
    ...ownerState.color === "error" && {
      backgroundColor: theme.palette.error[800],
      color: theme.palette.common.white,
      "&:hover": {
        backgroundColor: "#B3364C",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.3), 0px 0px 2px rgba(0, 0, 0, 0.15);"
      },
      "&:focus-visible": {
        backgroundColor: "#B63D52",
        boxShadow: `0px 0px 0px 1px ${theme.palette.common.white}, 0px 0px 0px 3px ${theme.palette.error[800]}, 0px 1px 2px 3px rgba(0, 0, 0, 0.3), 0px 1px 3px 4px rgba(0, 0, 0, 0.15);`
      },
      "&:active": {
        boxShadow: "none"
      },
      "&:disabled": {
        backgroundColor: alpha(theme.palette.grey[900], 0.12),
        color: alpha(theme.palette.grey[900], 0.38)
      }
    }
  };
};
export {
  filledStyles
};
